import React from 'react';
import { Box } from '@mui/material';

export const Card = ({ children, className = '', ...props }) => {
  return (
    <Box
      className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`}
      {...props}
    >
      {children}
    </Box>
  );
};

export const CardHeader = ({ children, className = '', ...props }) => {
  return (
    <Box
      className={`px-6 py-4 border-b border-gray-200 ${className}`}
      {...props}
    >
      {children}
    </Box>
  );
};

export const CardTitle = ({ children, className = '', ...props }) => {
  return (
    <h3
      className={`text-lg font-semibold text-gray-900 ${className}`}
      {...props}
    >
      {children}
    </h3>
  );
};

export const CardContent = ({ children, className = '', ...props }) => {
  return (
    <Box
      className={`px-6 py-4 ${className}`}
      {...props}
    >
      {children}
    </Box>
  );
}; 